import React from "react";
import { ReactNode } from "react";
import { ContainerWidth } from "./ContainerWidth.js";

type Props = {
  width?: ContainerWidth;
  children: ReactNode;
};

/**
 * Renders the main page container.
 */
export const Container = ({ width = "fixed", children }: Props) => {
  return <div className={getClassName(width)}>{children}</div>;
};

const getClassName = (width: ContainerWidth) => {
  if (width === "fixed-wide") {
    return "container-wide";
  } else if (width === "fixed-wide-min") {
    return "container-wide-min";
  } else if (width === "fluid") {
    return "container-fluid";
  } else {
    return "container";
  }
};
